<template>
    <div class="container">
        <loading-state
            v-if="loading">
        </loading-state>

        <template  v-if="stockItems.length > 0">
            <label class="text-normal">These parts will be supplied, based on the problems selected:</label>
            <div class="card card-body pb-0">
                <dl class="mb-0">
                    <dt>Parts</dt>
                    <dl v-for="(stockItem, index) in stockItems" :key="index">
                        {{stockItem.title}}
                    </dl>
                </dl>
            </div>
        </template>
        <div class="alert alert-info">
            <animated-info></animated-info>
            <div class="alert-content">
                <p>
                    If more parts are required, go back and update device problems.
                </p>
                <p>
                    If you've selected all relevant problems, but the parts are still not showing, contact your SSM to request an update.
                </p>
            </div>
        </div>

        <!-- Footer -->
        <fixed-footer
                :class="{'active': true}"
                :nextLabel="`Next`"
                :nextRoute="`revisit.note`"
                :prevRoute="`revisit.device-issues`">
        </fixed-footer>
    </div>
</template>

<script>
    export default {
        name: "RepairParts",

        data() {
            return {
                loading: true,
                stockItems: []
            }
        },

        mounted() {
            this.loadParts();
        },

        methods: {
            loadParts() {
                this.loading = true;
                this.$http.get(`/api/v4/warranty/booking/${localStorage.revisitBookingId}`)
                    .then(res => {
                        this.loading = false;
                        this.stockItems = res.data.data.stock_items;
                    })
            }
        }
    }
</script>

<style scoped>

</style>